(function() {
  var textEl = document.querySelector('[data-personalize-rotating-text]');
  if (!textEl) return;

  var texts;
  try { texts = JSON.parse(textEl.dataset.rotatingTexts || '[]'); } catch(e) { texts = []; }
  if (!texts.length) texts = ['Item Personalization', 'Add Initials', 'Add Monogram'];
  var currentIndex = 0;
  var interval = null;

  /* Cross-fade between elements that are already in the DOM. Writing
     textContent was what resized the box; toggling a class cannot. */
  var phrases = textEl.querySelectorAll('.personalize-product-btn__phrase');

  /* The monogram runs on its OWN clock, and a much slower one. It used to
     change on the phrase's 2.5s tick, which is the pace of something trying
     to get your attention; this is a finish being demonstrated, so it takes
     its time. Six seconds, and the press itself is under a second of it. */
  var mark = document.querySelector('[data-gc-mono-mark]');
  var monos = ['AB', 'GC', 'BG'];
  var monoIndex = 0;
  var monoTimer = null;

  function letters() {
    return mark ? mark.querySelectorAll('.gc-mono-letter') : [];
  }

  function rotateMono() {
    if (!mark) return;
    monoIndex = (monoIndex + 1) % monos.length;
    var next = monos[monoIndex];

    /* restart cleanly even if the previous press has not finished */
    mark.classList.remove('is-stamping');
    void mark.offsetWidth;

    /* The letter is swapped BEFORE the press begins, not partway through it.
       The old code changed it at 150ms, which meant the die was already down
       on the letter it was about to replace — the swap was visible, and it is
       most of why the effect read as a crossfade. */
    var ls = letters();
    for (var i = 0; i < ls.length; i++) {
      var ch = next.charAt(i) || '';
      /* The letter's gold now lives in a .gc-mono-glyph child rather than in a
         bare text node on the letter itself, so firstChild is an ELEMENT and
         assigning to its nodeValue is a silent no-op. data-l still has to be
         set: the two pseudo-elements that draw the walls of the impression
         take their content from it. */
      var glyph = ls[i].querySelector('.gc-mono-glyph');
      if (glyph) glyph.textContent = ch;
      ls[i].setAttribute('data-l', ch);
    }
    mark.setAttribute('data-mono', next);
    stamp();
  }

  /* Replays the press on whatever letters are showing. Split out of
     rotateMono so the mark can be struck without also changing the initials —
     which is what the first one, below, needs to do. */
  function stamp() {
    if (!mark) return;
    mark.classList.remove('is-stamping');
    void mark.offsetWidth;
    mark.classList.add('is-stamping');
    /* BACKSTOP. is-stamping is normally removed by the animationend handler,
       which waits for gcHeat on the last letter. Under
       prefers-reduced-motion:reduce the CSS sets animation:none on the heat,
       so that event never fires and the class would stay on for good. It is
       harmless there — every animation it gates is also none — but a class
       that can never come off is a trap for the next person. 1300ms is past
       the longest chain (.19s delay + .92s heat). */
    window.setTimeout(function () { mark.classList.remove('is-stamping'); }, 1300);
  }

  if (mark) {
    /* the heat outlasts the press, so the class comes off on the LAST of the
       animations to finish rather than the first */
    mark.addEventListener('animationend', function (e) {
      if (e.animationName !== 'gcHeat') return;
      var ls = letters();
      if (!ls.length || e.target === ls[ls.length - 1].querySelector('.gc-mono-heat')) {
        mark.classList.remove('is-stamping');
      }
    });
  }

  function rotateText() {
    if (phrases.length > 1) {
      var next = (currentIndex + 1) % phrases.length;
      phrases[currentIndex].classList.remove('is-active');
      phrases[next].classList.add('is-active');
      currentIndex = next;
      return;
    }
    /* older markup, still one node: keep the previous behaviour */
    textEl.classList.add('is-fading');
    setTimeout(function() {
      currentIndex = (currentIndex + 1) % texts.length;
      textEl.textContent = texts[currentIndex];
      textEl.classList.remove('is-fading');
    }, 300);
  }

  var struckOnce = false;

  function startRotation() {
    if (interval) return;
    interval = setInterval(rotateText, 2500);
    /* its own period, and long enough that the mark is still most of the time */
    if (mark && !monoTimer) {
      monoTimer = setInterval(rotateMono, 6000);
      /* THE FIRST STRIKE. Until now the earliest press was the first 6s tick,
         so a shopper who scrolled the button into view and clicked inside six
         seconds never saw the effect at all — the button just sat there with
         two static letters on it. One press shortly after the button appears
         is what actually demonstrates the finish being sold. It only changes
         letters from the tick after, so the initials are not swapped out from
         under someone who is already reading them. */
      if (!struckOnce) {
        struckOnce = true;
        window.setTimeout(stamp, 650);
      }
    }
  }

  function stopRotation() {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
    if (monoTimer) { clearInterval(monoTimer); monoTimer = null; }
  }

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          startRotation();
        } else {
          stopRotation();
        }
      });
    }, { threshold: 0 });
    observer.observe(textEl);
  } else {
    startRotation();
  }
})();
